import { useMediaQuery } from "@react-hook/media-query";

import type { IBreakpoint } from "@constants";

export const useMinMedia = (breakpoint: IBreakpoint) => {
  return useMediaQuery(`only screen and (min-width: ${breakpoint}px)`);
};

export const useMaxMedia = (breakpoint: IBreakpoint) => {
  return useMediaQuery(`only screen and (max-width: ${breakpoint}px)`);
};
